import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContentBlockOverviewComponent } from './containers/content-block-overview/content-block-overview.component';

const routes: Routes = [
  {
    path: '',
    component: ContentBlockOverviewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContentBlocksRoutingModule {}
